import { render, staticRenderFns } from "./ModalCoinHistory.vue?vue&type=template&id=721f68d2&scoped=true&lang=pug&"
import script from "./ModalCoinHistory.vue?vue&type=script&lang=ts&"
export * from "./ModalCoinHistory.vue?vue&type=script&lang=ts&"
import style0 from "./ModalCoinHistory.vue?vue&type=style&index=0&id=721f68d2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721f68d2",
  null
  
)

export default component.exports